import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import "../SignupPages/SignupCommon.css";

const IntakeFormPage9: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const completeIntakeStep6 = localStorage.getItem("complete-intake-step6");
    if (completeIntakeStep6) {
      navigate("/complete-intake/step-6b", { replace: true });
    } else {
      navigate("/complete-intake/step-6", { replace: true });
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);
  };

  const handleNext = () => {
    if (selectedOption) {
      localStorage.setItem(
        "weight_loss_medication",
        JSON.stringify({
          key: "weight_loss_medication",
          value: selectedOption,
        })
      );
    }
    navigate("/complete-intake/step-7");
    localStorage.setItem("complete-intake-step6b", "true");
  };

  useEffect(() => {
    const savedWeightLoss = localStorage.getItem("weight_loss_medication");

    if (savedWeightLoss) {
      const parsedWeightLoss = JSON.parse(savedWeightLoss);
      setSelectedOption(parsedWeightLoss.value);
    }
  }, []);

  const options = ["Yes", "No"];

  const step = 6;

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={65} step={step} />
        <div className="signup-content">
          <p className="signup-intro">
            Are you currently taking or have recently (within the last 12
            months) taken medication (GLP-1 or non-GLP1) for weight loss?
          </p>
          <div className="options">
            {options.map((option) => (
              <label
                key={option}
                className={selectedOption === option ? "selected" : ""}
                onClick={() => handleOptionClick(option)}
              >
                {option}
              </label>
            ))}
          </div>
          <button
            className="next-btn sticky-btn"
            onClick={handleNext}
            disabled={!selectedOption}
          >
            Continue →
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage9;
